import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import cn from 'classnames';

import Layout from '../Layout';
import Section from '../Section';

import styles from './styles';

const useStyles = makeStyles(styles);

const LayoutLogged = ({ children, className }) => {
  const classes = useStyles();

  return (
    <Layout>
      <Section className={cn(classes.layoutLoggedContentConntainer, className)}>
        {children}
      </Section>
    </Layout>
  );
};

LayoutLogged.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

LayoutLogged.defaultProps = {
  className: undefined,
};

export default LayoutLogged;
